import { bridgeConfigDelegates } from './bridge-config-delegates';
import { getContext, invoke, getFrameId, reload } from './core';
import { enableTheming } from './enableTheming';
import { on, emit } from './events';
import { initFeatureFlags, trackFeatureFlagEvent } from './featureFlags';
import { fetchProduct } from './fetchProduct';
import { fetchRemote } from './fetchRemote';
import { fetchUserRecommendations } from './fetchUserRecommendations';
import { emitFrontendCustomMetric } from './frontendCustomMetrics';
import { emitFrontendLogs } from './frontendLogs';
import { createHistory } from './history';
import { getUrl, navigate } from './navigation';
import { closePanel, openPanel } from './panel';
import { permissionBridgeMethods } from './permissions';
import { onPublic, emitPublic } from './publicEvents';
import { subscribeRealtimeChannel, publishRealtimeChannel } from './realtime';
import { requestTeamworkGraph } from './requestTeamworkGraph';
import { openRovo, isRovoEnabled, setRovoContext } from './rovo';
import { iframeAnalytics, trackObjectStoreAction, ufoEvent } from './telemetry';
import type { TAnyBridgeMethod } from './types';

export const bridgeMethods: Record<string, TAnyBridgeMethod> = {
	...bridgeConfigDelegates,
	// Core methods
	getContext,
	invoke,
	getFrameId,
	reload,
	// Fetch methods
	fetchProduct,
	fetchRemote,
	fetchUserRecommendations,
	requestTeamworkGraph,
	// Theming methods
	enableTheming,
	// Event methods
	on,
	emit,
	// Public event methods
	onPublic,
	emitPublic,
	// Realtime methods
	subscribeRealtimeChannel,
	publishRealtimeChannel,
	// Navigation methods
	getUrl,
	navigate,
	// Panel methods
	openPanel,
	closePanel,
	// History methods
	createHistory,
	// Feature flag methods
	initFeatureFlags,
	trackFeatureFlagEvent,
	// Frontend observability
	emitFrontendCustomMetric,
	emitFrontendLogs,
	// Telemetry methods
	'iframe-analytics': iframeAnalytics,
	trackObjectStoreAction,
	'ufo-event': ufoEvent,
	// Rovo methods
	isRovoEnabled,
	openRovo,
	setRovoContext,
	// Permission methods
	...permissionBridgeMethods,
};
